module.exports = __webpack_public_path__ + "img/cool-icon.f5915f7a.svg";